import Vue from 'vue'
import Router from 'vue-router'
import Dashboard from './views/Dashboard.vue'
import MainLayout from "./views/MainLayout"
import Login from './views/Login'
import CreativeIndustries from "./views/CreativeIndustries"
import CreativeJobs from "./views/CreativeJobs"
import IndexManager from "./views/IndexManager"
import DataManager from "./views/DataManager"
import UserManager from "./views/UserManager"
import Downloads from "./views/Downloads"
import PowerBI from "./views/PowerBI"
import DeveloperManage from "./views/DeveloperManage"
import DeveloperManageGroup from "./views/DeveloperManageGroup"
import { baseUrl } from "./services/Constants";


Vue.use(Router);

export default new Router({
  base: baseUrl,
  mode: 'history',
  routes: [
    {
      path: '/login',
      name: 'login',
      component: Login
    },
    {
      path: '/',
      name: 'main-layout',
      component: MainLayout,
      children: [
        {
          path: '/',
          name: 'dashboard',
          component: Dashboard
        },
        {
          path: '/dashboard',
          name: 'dashboard',
          component: Dashboard
        },
        {
          path: `/dashboard/:section`,
          name: 'dashboard',
          component: Dashboard,
          props: true
        },
        {
          path: `/creative-industries/:section`,
          name: 'creative-industries',
          component: CreativeIndustries,
          props: true
        },
        {
          path: `/creative-jobs/:section`,
          name: 'creative-jobs',
          component: CreativeJobs,
          props: true
        },
        {
          path: `/index-manager/:section`,
          name: 'index-manager',
          component: IndexManager,
          props: true
        },
        {
          path: `/data-manager/:section`,
          name: 'data-manager',
          component: DataManager,
          props: true
        },
        {
          path: `/user-manager/:section`,
          name: 'user-manager',
          component: UserManager,
          props: true
        },
        {
          path: `/downloads`,
          name: 'downloads',
          component: Downloads,
          props: true
        },
        {
          path: `/power-bi-manage/:section`,
          name: 'main-page',
          component: PowerBI,
          props: true
        },
        {
          path: `/developer-manage/manage`,
          name: 'developer-manage',
          component: DeveloperManage,
          // props: true
        },
        /**
          * Author: thiracupt ponngern
          * Detail: add new route
          */
        {
          path: `/developer-manage/manage-group`,
          name: 'developer-manage-group',
          component: DeveloperManageGroup,
        },
        {
          path: `/power-bi-manage/:section`,
          name: 'creative-index-page',
          component: PowerBI,
          props: true
        },
        {
          path: `/power-bi-manage/:section`,
          name: 'data-and-static-page',
          component: PowerBI,
          props: true
        },
      ]
    }
  ]
})
